import React, { useEffect, useState } from "react"
import { formatDateDataGrid } from "src/utils/format-date"
import PropTypes from 'prop-types'
import dayjs from "dayjs"
import { DATE_FORMAT } from "src/utils/constants"
import DatalakeService from "src/services/datalake-service"
import ParameterPaginationTable from "src/components/table/parameter-pagination-table"

const ParameterDatalakeAmortDeprecDFCAuxCVMTable = (props) => {
    const dataLakeService = new DatalakeService()
    const [data, setData] = useState([])
    const [pagination, setPagination] = useState({ count: 0, next: null, previous: null })

    useEffect(() => {
        loadData()
    }, [])

    const loadData = () => {
        props.loading(true)
        dataLakeService.loadPaginationEndpoint(props.endpoint).then((response) => {
            props.loading(false)

            const { body } = response
            const { results, count, next, previous } = body
            const list = results.map((obj, index) => ({ ...obj, id: index }))
            setPagination({ count: count, next: next, previous: previous })
            setData(list)
        })
    }

    const createRow = async () => {
        const body = {
            "CPFCNPJ": null,
            "DataReferencia": null,
            "GrupoBalanco": null,
            "Versao": null,
            "ID_DF": null,
            "SaldoContaAnualizadoReais": null,
            "MarcacaoConsolidacao": "N/A",
            "TipoDemonstrativo": "N/A",
            "CodigoConta": null,
            "DescricaoConta": null
        }

        console.log("DataReferencia:", body.DataReferencia)

        props.loading(true)
        return dataLakeService.createTableEndpoint(props.endpoint, body).then(() => {
            props.loading(false)
            loadData(0, 25)
        }).catch((err) => {
            props.loading(false)
            throw err
        })
    }

    const updateRow = async (newRow) => {
        const { ID, CPFCNPJ, DataReferencia, GrupoBalanco, Versao, ID_DF, SaldoContaAnualizadoReais, MarcacaoConsolidacao, TipoDemonstrativo, CodigoConta, DescricaoConta
            } = newRow

        const body = {
            "CPFCNPJ": CPFCNPJ,
            "DataReferencia": DataReferencia,
            "GrupoBalanco": GrupoBalanco,
            "Versao": Versao,
            "ID_DF": ID_DF,
            "SaldoContaAnualizadoReais": SaldoContaAnualizadoReais,
            "MarcacaoConsolidacao": MarcacaoConsolidacao,
            "TipoDemonstrativo": TipoDemonstrativo,
            "CodigoConta": CodigoConta,
            "DescricaoConta": DescricaoConta
        }

        props.loading(true)
        return dataLakeService.updateTableEndpoint(props.endpoint, ID, body).then(() => {
            props.loading(false)
        }).catch((err) => {
            props.loading(false)
            throw err
        })
    }

    const deleteRow = async (row) => {
        props.loading(true)
        const { ID } = row
        return dataLakeService.deleteTableEndpoint(props.endpoint, ID).then(() => {
            props.loading(false)
            const listRemoved = data.filter((item) => item.ID !== ID)
            setData(listRemoved)
        }).catch((err) => {
            props.loading(false)
            throw err
        })
    }

    const onFilter = async (filterList, limit, offset) => {
        const query = filterList.map(obj => `${encodeURIComponent(obj.field)}=${encodeURIComponent(obj.value)}`).join('&')

        props.loading(true)
        dataLakeService.loadPaginationEndpoint(props.endpoint, query, limit, offset).then((response) => {
            props.loading(false)
            const { body } = response
            const { results, count, next, previous } = body
            const list = results.map((obj) => ({ ...obj, id: obj.ID }))
            setPagination({ count: count, next: next, previous: previous })
            setData(list)
        })
    }

    const changePage = async (endpoint) => {
        props.loading(true)
        dataLakeService.paginate(endpoint).then((response) => {
            props.loading(false)
            const { body } = response
            const { results, count, previous, next } = body
            const list = results.map((obj) => ({ ...obj, id: obj.ID }))

            setPagination({ count: count, next: next, previous: previous })
            setData([])
            setData(list)
        })
    }

    const columns = [
        {
            field: 'ID',
            headerName: '#',
            disableColumnMenu: true,
            disableFilter: true,
            flex: true,
            minWidth: 80,
        },
        {
            field: 'CPFCNPJ',
            headerName: 'CPFCNPJ',
            disableColumnMenu: true,
            disableFilter: true,
            flex: true,
            minWidth: 150
        },
        {
            field: 'DataReferencia',
            headerName: 'DataReferencia',
            disableColumnMenu: true,
            disableFilter: true,
            flex: true,
            minWidth: 150,
            type: 'date',
            valueGetter: ({ value }) => (value ? new Date(value) : null),
                        valueFormatter: ({ value }) => value instanceof Date && !isNaN(value) ? dayjs(value).format(DATE_FORMAT): '',
        },
        {
            field: 'GrupoBalanco',
            headerName: 'GrupoBalanco',
            disableColumnMenu: true,
            disableFilter: true,
            flex: true,
            minWidth: 150
        },
        {
            field: 'Versao',
            headerName: 'Versao',
            disableColumnMenu: true,
            disableFilter: true,
            flex: true,
            minWidth: 150,
            type: 'number'
        },
        {
            field: 'ID_DF',
            headerName: 'ID_DF',
            disableColumnMenu: true,
            disableFilter: true,
            flex: true,
            minWidth: 150
        },
        {
            field: 'SaldoContaAnualizadoReais',
            headerName: 'SaldoContaAnualizadoReais',
            disableColumnMenu: true,
            disableFilter: true,
            flex: true,
            minWidth: 150,
            type: 'number'
        },
        {
            field: 'MarcacaoConsolidacao',
            headerName: 'MarcacaoConsolidacao',
            disableColumnMenu: true,
            disableFilter: true,
            flex: true,
            minWidth: 150
        },
        {
            field: 'TipoDemonstrativo',
            headerName: 'TipoDemonstrativo',
            disableColumnMenu: true,
            disableFilter: true,
            flex: true,
            minWidth: 150
        },
        {
            field: 'CodigoConta',
            headerName: 'CodigoConta',
            disableColumnMenu: true,
            disableFilter: true,
            flex: true,
            minWidth: 150
        },
        {
            field: 'DescricaoConta',
            headerName: 'DescricaoConta',
            disableColumnMenu: true,
            disableFilter: true,
            flex: true,
            minWidth: 150
        },
        {
            field: 'CriadoEm',
            headerName: 'Data de Criação',
            flex: true,
            minWidth: 150,
            disableColumnMenu: true,
            disableFilter: true,
            renderCell: (params) => formatDateDataGrid(params)
        },
        {
            field: 'AtualizadoEm',
            headerName: 'Data de Atualização',
            flex: true,
            minWidth: 150,
            disableColumnMenu: true,
            disableFilter: true,
            renderCell: (params) => formatDateDataGrid(params)
        }
    ]

    return (
        <div>
            <ParameterPaginationTable
                columns={columns}
                data={data}
                setData={setData}
                createRow={createRow}
                deleteRow={deleteRow}
                updateRow={updateRow}
                filterFunction={onFilter}
                pagination={pagination}
                onChangePage={changePage}
                customFilter={true} />
        </div>
    )
}

ParameterDatalakeAmortDeprecDFCAuxCVMTable.propTypes = {
    loading: PropTypes.func,
    endpoint: PropTypes.string,
}

export default ParameterDatalakeAmortDeprecDFCAuxCVMTable